// extracted by mini-css-extract-plugin
export var option = "_94-0";
export var optionCard = "_94-f";
export var optionContent = "_94-g";
export var optionIcon = "_94-i";
export var optionIconBox = "_94-h";
export var optionLabel = "_94-j";
export var optionPill = "_94-m";
export var optionPillBadge = "_94-p";
export var optionPillIcon = "_94-n";
export var optionPillLabel = "_94-o";
export var optionRadio = "_94-k";
export var optionRadioInner = "_94-l";
export var optionReveal = "_94-2";
export var optionRevealDelay0 = "_94-3";
export var optionRevealDelay1 = "_94-4";
export var optionRevealDelay10 = "_94-d";
export var optionRevealDelay11 = "_94-e";
export var optionRevealDelay2 = "_94-5";
export var optionRevealDelay3 = "_94-6";
export var optionRevealDelay4 = "_94-7";
export var optionRevealDelay5 = "_94-8";
export var optionRevealDelay6 = "_94-9";
export var optionRevealDelay7 = "_94-a";
export var optionRevealDelay8 = "_94-b";
export var optionRevealDelay9 = "_94-c";
export var optionSelected = "_94-1";